/**
 * Labstep
 *
 * @module components/Entity/Action/Tag
 * @desc Action to tag entity. Opens modal showing tag manager.
 */

import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import TagManager from 'labstep-web/components/Tag/Manager';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type React from 'react';
import type { EntityActionTagProps } from './types';

export const EntityActionTag: React.FC<EntityActionTagProps> = ({
  parentEntity,
}) => (
  <Can
    entityName={parentEntity.entityName}
    id={parentEntity.idAttr}
    action={Action.tag_add_remove}
  >
    <TagManager
      parentEntity={parentEntity}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          dataCy="components/Entity/Action/Tag"
          type="option"
          onClick={toggleModal}
          text={'Add Tags'}
          icon={ICONS.entity.actions.tag}
        />
      )}
    />
  </Can>
);
